import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f5191b6c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=f5191b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5191b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5191b6c')) {
      api.createRecord('f5191b6c', component.options)
    } else {
      api.reload('f5191b6c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=f5191b6c&scoped=true&", function () {
      api.rerender('f5191b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OfT77Clry80d/JS/comp/Voucher.vue"
export default component.exports